import React from 'react';

export const orderCashReturnPembukuanConfig = [
  {
    path: '/cashreturn-pembukuan',
    component: React.lazy(() => import('./pembukuan/index')),
  },
  {
    path: '/cashreturn-pembukuan/rincian-order',
    component: React.lazy(() => import('./rincianOrder/index')),
  },
];
